module.exports = __webpack_public_path__ + "img/recycle.e6e8258d.svg";